<template>

    <div class="container ">




        <div class="wrap">

      
                <h3 class="entry-title" > <i class="fas fa-check"></i> Dziękujemy za Podpisanie umowy, poinformujemy Cię o wypłacie pożyczki e-mailem oraz sms. </h3>
        


<br><br>



        </div>

    </div>

</template>

<script>




    export default {

       name: 'FingoThankYouView',
      


       data(){

            return {

                isSigned: false,

                showThanks: true,

                showSignature: true
            }
       },


       computed: {

       },
       methods: {



        gotomain(){

            this.$router.push({path: '/'});
        }
       },




       mounted(){



            // scroll to top with .5s delay
            this.pageTop();

       }




    }
</script>

<style scoped>


h3 i {
    color: #0bc268;
}


.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:center;
}

.button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}






.fade-enter-active,.fade-leave-active {
  transition: opacity 3s
}
.fade-enter,.fade-leave-active {
  opacity: 0
}


.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,.slide-fade-leave-active {
  padding-left: 10px;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/FingoThankYouView.vue